import Runner from '@protonapp/proton-runner-rn0772'
import legacyRunner from '@protonapp/proton-runner'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

export function getRunnerByReactNativeVersion(useNewReactNative) {
  if (useNewReactNative) {
    console.debug("Use runner with new react native version")
    return withLDConsumer()(Runner)
  } else {
    console.debug("Use runner with legacy react native version")
    return withLDConsumer()(legacyRunner)
  }
}
